(function() {
  /* Show cart drawer when product added to cart */
  document.addEventListener('theme:cart:popdown', (e) => {
    const listener = (e) => {
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
        new CustomEvent('theme:drawer:open', {
          bubbles: false,
        })
      );
      document.removeEventListener('theme:cart:change', listener);
    };
    document.addEventListener('theme:cart:change', listener);
  });
})();